import gql from 'graphql-tag';

export default gql`
  mutation RemoveActivityMutation($activityId: Int!) {
    dailyTracker {
      removeActivity(activityId: $activityId) {
        ... on BasicMutationSuccess {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          authCode: code
        }
      }
    }
  }
`;
